import * as React from 'react';
import Loading from './components/loading';
import Storage from './storage';
import ConfigService from './services/config-service';
import ePharmaServices from './services/epharma-services';
import keys from './util/keys';
import { AxiosRequestConfig } from 'axios';
import HomePage from './pages/home';
import StoreSearchPage from './pages/store-search';
import StoreList from './pages/store-search/list';
import CouponRegisterPage from './pages/coupon-register';
import Footer from './components/footer';
import Wrapper from './components/wrapper';
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { IStoreResponse } from './interfaces/store';
import Login from './pages/login';
import CouponBuilder from './pages/coupon-builder';
import PrivateRoute from './components/private-route';

export default function App()
{
    const [ loading, setLoading ] = React.useState(true);
    const [ stores, setStores ] = React.useState([] as IStoreResponse[]);
    const [ infoMessage, setInfomessage ] = React.useState('');

    const listRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => { authenticate(); }, []);

    const authenticate = async () =>
    {
        const baseUrl = await ConfigService().getConfig(keys.BaseUrlOauth);
        const authenticateUrl = await ConfigService().getConfig(keys.OauthUrl);

        const username = await ConfigService().getConfig(keys.UserNameOauth);
        const password = await ConfigService().getConfig(keys.PasswordOauth);
        const clientId = await ConfigService().getConfig(keys.ClientId);

        setTimeout(async () =>
        {
            const request = ePharmaServices(baseUrl);

            request.interceptors.request.use((config: AxiosRequestConfig) =>
            {
                if (!config.headers) config.headers = {} as any;
                (config.headers as any)["username"] = username;
                (config.headers as any)["password"] = password;
                (config.headers as any)["client_id"] = clientId;
                
                return config;
            });
    
            const response = await request.get(authenticateUrl);
    
            setLoading(false);
            const tokenResp = response && response.data && response.data.data ? response.data.data.token : null;
            const tokenToSave = typeof tokenResp === 'string' ? { accessToken: tokenResp, expires: '' } : tokenResp;
            Storage.token.set(tokenToSave);
        }, 2000);
    };

    return (
        <>
            <Wrapper>
                <BrowserRouter>
                    <Switch>
                        <Route path="/" exact component={HomePage} />
                        {
                            !loading &&
                                <>
                                    <Route
                                        path="/store-search"
                                        exact
                                        component={() =>
                                        <>
                                            <StoreSearchPage
                                                setInfoMessage={infoMessage => setInfomessage(infoMessage)}
                                                setStores={stores =>
                                                {
                                                    setStores(stores);
                                                    listRef.current && listRef.current.scrollIntoView();
                                                }}
                                            />
                                            {
                                                (stores.length > 0 || infoMessage !== "") &&
                                                    <StoreList
                                                        setRef={ref => { listRef.current = ref } }
                                                        items={stores}
                                                        infoMessage={infoMessage}        
                                                    />
                                            }
                                        </>}
                                    />
                                    <Route
                                        path="/coupon-register"
                                        exact
                                        component={CouponRegisterPage}
                                    />
                                    <Route path="/login" exact component={Login} />
                                    <PrivateRoute path="/coupon-builder" component={CouponBuilder} />
                                </>
                        }
                    </Switch>
                </BrowserRouter>
            </Wrapper>
            <Footer />
            <Loading show={loading} />
        </>
    );
}